require('./ruleTemplateSettings.i18n.json');
require('./ruleTemplateSettings.tpl.html');

/*@ngInject*/
const RuleTemplateSettingsController = function ($rootScope, $scope, $uibModalInstance, localization, coreConstant, dataSetUtil,
                                                 ruleModel, ruleEntryStatus, ruleMediator, ruleActionsUtil, options, $state, navigationStateModel) {

    var translations;

    $scope.viewModel = {
        rule: {},
        title: '',
        ruleSetItemList: [],
        ruleName: '',
        selectedRuleSet: null,
        tagItems: [],
        addTagItems: [],
        newTag: '',
        selectedRuleTemplateName: '',
        description: '',
        hasChanges: false,
        addTag: ''
    };

    function initViewModelFromRule(rule) {
        $scope.viewModel.rule = rule;
        $scope.viewModel.ruleName = rule.name;
        $scope.viewModel.description = rule.description;
        $scope.viewModel.tagItems = rule.tags;
    }


    localization.getTranslationByKey('ruleTemplateSettings').then(function (result) {
        translations = result;

        $scope.viewModel.addTag = translations.addTag;

        function loadData() {
            $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);

            if (!options.rule) {
                $scope.viewModel.title = translations.newRuleTitle;
                $scope.viewModel.saveButton = translations.createNewRule;
            }
            else {
                $scope.viewModel.title = translations.updateRuleTitle;
                $scope.viewModel.saveButton = translations.updateRule;
                initViewModelFromRule(options.rule);
            }

            var ruleDataSetName = 'Advanced Filter Rule Set',
                submissionUri = null,
                variableName = 'ruleSets',
                dataSetParams = dataSetUtil.getDataSetParamsByName(ruleDataSetName, variableName, submissionUri);

            dataSetUtil.getDataItems(dataSetParams).then(function (items) {
                $scope.viewModel.ruleSetItemList = items;
                if ($scope.viewModel.rule.id) {
                    _.each(items, function (ruleSet) {
                        if (parseInt(ruleSet.value) === $scope.viewModel.rule.parentId) {
                            $scope.viewModel.selectedRuleSet = ruleSet;
                        }
                    });
                }
            }.bind(this));
        }

        $scope.viewModel.selectedRuleTemplateName = translations.selectRuleSet;
        loadData();
    });

    $scope.addNewTag = function (item) {
        var customTag = {};
        if ($scope.viewModel.tagItems.length < 10) {

            if (item.hasOwnProperty('customTagName')) {
                customTag.name = item.name.replace(/['"]+/g, '');
                customTag.type = 'custom';
                $scope.viewModel.tagItems.push(customTag);
            } else {
                $scope.viewModel.tagItems.push(item);
            }

            $scope.viewModel.newTag = '';
            $scope.viewModel.addTagItems = [];
            $scope.viewModel.addTag = translations.addTag;

        } else {
            $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'tagsCountExceededMessage'));
        }
        $scope.handleChange();
    };

    $scope.onDeleteTag = function (tag) {
        _.remove($scope.viewModel.tagItems, function (item) {
            return item.name === tag.name;
        });
        $scope.handleChange();
        $scope.viewModel.newTag = '';
        $scope.viewModel.addTagItems = [];
    };

    $scope.addTag = function () {
        return new Promise(function (resolve, reject) {
            var count=0,
                tagItemList=[];
            if ($scope.viewModel.tagItems.length===0) {
                resolve(tagItemList);
            }
            else {
                _.forEach($scope.viewModel.tagItems, function (item) {
                    if (item.hasOwnProperty('type')) {
                        ruleMediator.createTag({name: item.name}).then(function (result) {
                            tagItemList.push(result);
                            count++;
                            if (count === $scope.viewModel.tagItems.length) {
                                count = 0;
                                resolve(tagItemList);
                            }
                        }.bind(this));
                    } else {
                        tagItemList.push(item);
                        count++;
                        if (count === $scope.viewModel.tagItems.length) {
                            count = 0;
                            resolve(tagItemList);
                        }
                    }
                });
            }
        });
    };

    $scope.onConfirm = function () {

        $scope.addTag().then(function (tagItemList) {

            var rule = $scope.viewModel.rule;
            rule.name = $scope.viewModel.ruleName;
            rule.parentPath = $scope.viewModel.selectedRuleSet.name;
            rule.parentId = parseInt($scope.viewModel.selectedRuleSet.value);
            rule.description = $scope.viewModel.description;
            rule.tags = tagItemList;
            rule.objectUri = '/Rule';
            if (!rule.id) {
                rule.status = ruleEntryStatus.STATUS_ACTIVE;
                rule.condition = ruleMediator.createFieldRule().condition;
            }

            if (!rule.id) {
                ruleMediator.createRule(rule).then(function (result) {
                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'ruleSuccessfullyCreated'));
                    $uibModalInstance.close();

                    var navigationModel = {
                        parentState: 'configuration.rulesBrowser',
                        currentState: 'configuration.ruleBuilder',
                        data: {
                            ruleId: result.id,
                            ruleSetName: result.parentPath
                        }
                    };

                    $state.go('configuration.ruleBuilder', {
                        ruleId: result.id,
                        ruleSetName: result.parentPath
                    });
                    navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);

                });
            }
            else {
                ruleActionsUtil.saveRule($scope.viewModel.rule).then(function (result) {
                    $uibModalInstance.close();
                });
            }
        });
    };

    $scope.onSelectRuleSet = function (item) {
        $scope.viewModel.selectedRuleSet = item;
        $scope.viewModel.selectedRuleSet.name = item.name;
    };

    $scope.handleChange = function () {
        $scope.viewModel.hasChanges = true;
    };

    $scope.canEnableConfirmButton = function () {
        return (!_.isEmpty($scope.viewModel.ruleName) &&
            !_.isEmpty($scope.viewModel.selectedRuleSet) && $scope.viewModel.hasChanges);
    };

    $scope.$on('modal.closing', function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $scope.onCancel = function () {
        $uibModalInstance.close();
    };

    $scope.onTagNameChange = function () {
        var isNewTagExist = false,
            tag = {};
        if (_.isEmpty($scope.viewModel.newTag)) {
            $scope.viewModel.addTagItems = [];

        } else {
            ruleMediator.getMatchingTags($scope.viewModel.newTag).then(function (result) {
                $scope.viewModel.addTagItems = result;
                //removing the already added tag from the list
                _.forEach($scope.viewModel.tagItems, function (item) {
                    _.remove($scope.viewModel.addTagItems, function (tag) {
                        return item.id === tag.id;
                    });
                });

                _.forEach($scope.viewModel.addTagItems, function (tagItem) {
                    if (tagItem.name === $scope.viewModel.newTag) {
                        isNewTagExist = true;
                    }
                });

                _.forEach($scope.viewModel.tagItems, function (tagItem) {
                    if (tagItem.name === $scope.viewModel.newTag) {
                        isNewTagExist = true;
                    }
                });

                if (!isNewTagExist) {
                    tag.id = null;
                    tag.name = '"' + $scope.viewModel.newTag + '"';
                    tag.customTagName = translations.createNewTag;
                    $scope.viewModel.addTagItems.push(tag);
                }
            });
        }
    };

};

angular.module('ums.configuration')
    .controller('ruleTemplateSettingsController', RuleTemplateSettingsController);
